import { createContext, useContext, useEffect, useState } from "react";
import { Accounts_GetAll, Accounts_GetByID, Accounts_Update, Accounts_Delete, Accounts_Update_Password, Accounts_ResetPassword, Accounts_ResetPassword_Final, Accounts_Approve, Accounts_Reject, Accounts_Deactivate, Accounts_Reactivate, Accounts_Reinstate, Accounts_GetByID_Basic, Accounts_ResetPassword_Verify } from "../api/API_Accounts";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useStatus } from "./Context_Status_Global";
import _ from 'lodash';
const Context_Accounts = createContext();


export default function Context_Provider_Accounts({ children }) {
    const [User, User_Set] = useState(null);
    const [User_Permission, User_Permission_Set] = useState(null);
    const [User_Role, User_Role_Set] = useState(null);
    const [Accounts_List, Accounts_List_Set] = useState([]);
    const [Accounts_List_Approved, Accounts_List_Approved_Set] = useState([]);
    const [Accounts_List_Pending, Accounts_List_Pending_Set] = useState([]);
    const [Accounts_List_Deactivated, Accounts_List_Deactivated_Set] = useState([]);
    const [Accounts_List_Rejected, Accounts_List_Rejected_Set] = useState([]);
    const [Accounts_isLoading, Accounts_isLoading_Set] = useState(false);
    const [Accounts_Error, Accounts_Error_Set] = useState(null);
    const [Accounts_Selected, Accounts_Selected_Set] = useState(null);
    const [Accounts_ChangeInProgress, Accounts_ChangeInProgress_Set] = useState(null);
    const { Account, Logout } = useAuth();
    const { Status_Refresh, Data_Refresh, Status_Fetching_Set, Status_Saving, Status_Saving_Set, Confirmer_Confirm } = useStatus();
    const [Accounts_Mode, Accounts_Mode_Set] = useState(null);
    const Navigate = useNavigate();
    const [Accounts_Selector_List, Accounts_Selector_List_Set] = useState([]);

    useEffect(() => {
        let isMounted = true;
        const Load = async () => {
            // if (!Account?.Access?.Account?.Manage_Others) {
            //     Accounts_List_Set([]);
            //     Accounts_isLoading_Set(false);
            //     return;
            // }
            try {
                Accounts_isLoading_Set(true);
                Accounts_Error_Set(null);
                Status_Fetching_Set("InProgress");
                const Result = await Accounts_GetAll();
                if (!isMounted) { return; }

                const Processed = (Result.data || []).map(Data => ({
                    ...Data,
                    Role: User_Role_Get(Data, "List"),
                    Name_Compounded: `${Account_Name_Compound(Data.Name, 'Normal')}`,
                    Name_Compounded_Formal: `${Account_Name_Compound(Data.Name, 'Formal')}`
                }))

                Accounts_List_Set(Processed || []);
                Accounts_List_Approved_Set(Processed.filter(Account => Account.Approval.State === "Approved"));
                Accounts_List_Pending_Set(Processed.filter(Account => Account.Approval.State === "Pending"));
                Accounts_List_Deactivated_Set(Processed.filter(Account => Account.Approval.State === "Deactivated"));
                Accounts_List_Rejected_Set(Processed.filter(Account => Account.Approval.State === "Rejected"));
                Status_Fetching_Set("Success");
            } catch (Error) {
                if (!isMounted) { return; }
                Accounts_Error_Set(Error.message || "Failed to load accounts.");
                Status_Fetching_Set("Error");
            } finally {
                if (isMounted) {
                    Accounts_isLoading_Set(false);
                }
            }
        }
        Load();
        return () => {
            isMounted = false;
        };
    }, [Status_Refresh, Account?.Access?.Account?.Manage_Others]);

    const Account_Name_Compound = (Name, Type) => {
        if (Type === "Normal" || !Type) {
            return `${Name.First} ${Name.MI ? `${Name.MI}` : ``} ${Name.Last}`;
        } else if (Type === "Formal") {
            return `${Name.Last}, ${Name.First} ${Name.MI ? `${Name.MI}.` : ``}`;
        } else {
            return "";
        }

    }

    const Account_Fetch_ByID = async (ID) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Fetching_Set("InProgress");
        try {
            const Result = await Accounts_GetByID(ID);
            // console.error(Result.data);
            Accounts_Selected_Set(Result.data);
            Accounts_ChangeInProgress_Set(false);
            Status_Fetching_Set("Success");
            return Result.data;
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Fetching_Set("Error");
            throw Error;
        }
    }

    const Account_Update = async (ID, Payload) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Saving_Set("InProgress");
        console.warn(`Attempting to update ${ID}...`);
        try {
            await Accounts_Update(ID, Payload);
            Data_Refresh?.();
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Success");
            console.warn(`Update on ${ID} success`);
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Error");
            console.warn(`Update on ${ID} failed`);
            throw Error;
        }
    }

    const Account_Approve = async (ID) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Saving_Set("InProgress");
        console.warn(`Attempting to approve ${ID}...`);
        try {
            await Accounts_Approve(ID);
            Data_Refresh?.();
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Success");
            console.warn(`Approve on ${ID} success`);
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Error");
            console.warn(`Approve on ${ID} failed`);
            throw Error;
        }
    }

    const Account_Reject = async (ID, Reason) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Saving_Set("InProgress");
        console.warn(`Attempting to reject ${ID}...`);
        try {
            const Payload = {
                ID: ID,
                Reason: Reason || "Not specified"
            }
            await Accounts_Reject(Payload);
            Data_Refresh?.();
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Success");
            await Account_Fetch_ByID(ID);
            console.warn(`Reject on ${ID} success`);
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Error");
            console.warn(`Reject on ${ID} failed`);
            throw Error;
        }
    }

    const Account_Deactivate = async (ID) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Saving_Set("InProgress");
        console.warn(`Attempting to deactivate ${ID}...`);
        try {
            await Accounts_Deactivate(ID);
            Data_Refresh?.();
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Success");
            await Account_Fetch_ByID(ID);
            console.warn(`Deactivate on ${ID} success`);
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Error");
            console.warn(`Deactivate on ${ID} failed`);
            throw Error;
        }
    }

    const Account_Reactivate = async (ID) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Saving_Set("InProgress");
        console.warn(`Attempting to reactivate ${ID}...`);
        try {
            await Accounts_Reactivate(ID);
            Data_Refresh?.();
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Success");
            await Account_Fetch_ByID(ID);
            console.warn(`Reactivate on ${ID} success`);
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Error");
            console.warn(`Reactivate on ${ID} failed`);
            throw Error;
        }
    }

    const Account_Reinstate = async (ID) => {
        Accounts_ChangeInProgress_Set(true);
        Status_Saving_Set("InProgress");
        console.warn(`Attempting to reinstate ${ID}...`);
        try {
            await Accounts_Reinstate(ID);
            Data_Refresh?.();
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Success");
            await Account_Fetch_ByID(ID);
            console.warn(`Deactivate on ${ID} success`);
        } catch (Error) {
            Accounts_ChangeInProgress_Set(false);
            Status_Saving_Set("Error");
            console.warn(`Deactivate on ${ID} failed`);
            throw Error;
        }
    }

    const Accounts_Refresh = () => {
        Data_Refresh?.();
    }

    const Account_Fetch_ByID_FromState = (ID) => {
        try {
            const Data = Accounts_List.filter(Account => Account._id === ID)[0];
            return {
                Name: `${Data.Name.First} ${Data.Name.MI ? Data.Name.MI + "." : ""} ${Data.Name.Last}`,
                Email: Data.Email
            }
        } catch (Error) {
            return {
                Name: `Unknown`,
                Email: `Unknown`
            }
            
        }
    }

    const Account_Fetch_ByID_Basic = async (ID) => {
        if (!ID || ID === "Awaiting") {
            return { Name: "Deleted or unknown user" };
        }
        Status_Fetching_Set("InProgress");
        try {
            const Data = await Accounts_GetByID_Basic(ID);
            Status_Fetching_Set("Success");
            return {
                Name: `${Data.data.Name.First} ${Data.data.Name.MI ? Data.data.Name.MI + "." : ""} ${Data.data.Name.Last}`,
                Email: Data.data.Email
            }
        } catch (Error) {
            console.error(Error);
            Status_Fetching_Set("Success");
            return {
                Name: "Deleted or unknown user"
            }
        }
    }

    const Accounts_Fetch_ByID_Many_Basic = async (IDs) => {
        try {
            const uniqueIDs = [...new Set(IDs.filter(Boolean))]; // dedupe & ignore null
            const promises = uniqueIDs.map(id => Account_Fetch_ByID_Basic(id));
            const results = await Promise.all(promises);

            // map back to object { id: { Name, Email } }
            const mapped = {};
            uniqueIDs.forEach((id, idx) => {
                mapped[id] = results[idx];
            });

            return mapped;
        } catch (err) {
            console.error("Error fetching accounts:", err);
            return {};
        }
    };

    const Pattern_Teacher = {
        InteractiveMap: {
            View: true,
            Edit: false
        },
        Schedules: {
            View: true
        },
        Reservation: {
            Create: true,
            Edit: false,
            Overwrite: false,
            Approve: {
                Initial: false,
                Final: false
            },
            Delegateable: true
        },
        Report: {
            View: true,
            ScheduleTimetable: true,
            RoomUtilization: false,
            MapOverview: true,
            ReservationSlip: true,
            AccountList: false,
            ActivityLog: false
        },
        Account: {
            Manage_Self: true,
            Manage_Others: false
        },
        Templating: {
            View: false,
            Edit: false
        }
    }

    const Pattern_Staff = {
        InteractiveMap: {
            View: true,
            Edit: false
        },
        Schedules: {
            View: true
        },
        Reservation: {
            Create: true,
            Edit: true,
            Overwrite: false,
            Approve: {
                Initial: true,
                Final: false
            },
            Delegateable: true
        },
        Report: {
            View: true,
            ScheduleTimetable: true,
            RoomUtilization: false,
            MapOverview: true,
            ReservationSlip: true,
            AccountList: false,
            ActivityLog: false
        },
        Account: {
            Manage_Self: true,
            Manage_Others: false
        },
        Templating: {
            View: false,
            Edit: false
        }
    }

    const Pattern_Administrator = {
        InteractiveMap: {
            View: true,
            Edit: true
        },
        Schedules: {
            View: true
        },
        Reservation: {
            Create: true,
            Edit: true,
            Overwrite: false,
            Approve: {
                Initial: false,
                Final: true
            },
            Delegateable: true
        },
        Report: {
            View: true,
            ScheduleTimetable: true,
            RoomUtilization: true,
            MapOverview: true,
            ReservationSlip: true,
            AccountList: true,
            ActivityLog: true
        },
        Account: {
            Manage_Self: true,
            Manage_Others: true
        },
        Templating: {
            View: true,
            Edit: true
        }
    }

    const Pattern_Guard = {
        InteractiveMap: {
            View: true,
            Edit: false
        },
        Schedules: {
            View: true
        },
        Reservation: {
            Create: false,
            Edit: false,
            Overwrite: false,
            Approve: {
                Initial: false,
                Final: false
            },
            Delegateable: true
        },
        Report: {
            View: false,
            ScheduleTimetable: false,
            RoomUtilization: false,
            MapOverview: false,
            ReservationSlip: false,
            AccountList: false,
            ActivityLog: false
        },
        Account: {
            Manage_Self: true,
            Manage_Others: false
        },
        Templating: {
            View: false,
            Edit: false
        }
    }

    const Pattern_Staff_GSU = {
        InteractiveMap: {
            View: true,
            Edit: false
        },
        Schedules: {
            View: true
        },
        Reservation: {
            Create: true,
            Edit: false,
            Overwrite: false,
            Approve: {
                Initial: false,
                Final: false
            },
            Delegateable: true
        },
        Report: {
            View: true,
            ScheduleTimetable: true,
            RoomUtilization: true,
            MapOverview: true,
            ReservationSlip: true,
            AccountList: false,
            ActivityLog: false
        },
        Account: {
            Manage_Self: true,
            Manage_Others: false
        },
        Templating: {
            View: false,
            Edit: false
        }
    }

    const Pattern_Empty = {
        InteractiveMap: {
            View: false,
            Edit: false
        },
        Schedules: {
            View: false
        },
        Reservation: {
            Create: false,
            Edit: false,
            Overwrite: false,
            Approve: {
                Initial: false,
                Final: false
            },
            Delegateable: false
        },
        Report: {
            View: false,
            ScheduleTimetable: false,
            RoomUtilization: false,
            MapOverview: false,
            ReservationSlip: false,
            AccountList: false,
            ActivityLog: false
        },
        Account: {
            Manage_Self: false,
            Manage_Others: false
        },
        Templating: {
            View: false,
            Edit: false
        }
    }

    useEffect(() => {
        User_Set(Account);
        User_Permission_Set(Account?.Access);
        User_Role_Get(Account);
    }, [Account]);

    const User_Role_Get = (User, Origin) => {
        if (!User) { return; }
        if (!Origin) {
            if (User.isSystemAdmin) {
                User_Role_Set("System Admin");
                return;
            }
            if (_.isEqual(User.Access, Pattern_Teacher)) {
                User_Role_Set("Teacher");
            } else if (_.isEqual(User.Access, Pattern_Guard)) {
                User_Role_Set("Guard");
            } else if (_.isEqual(User.Access, Pattern_Staff)) {
                User_Role_Set("OSA Staff");
            } else if (_.isEqual(User.Access, Pattern_Staff_GSU)) {
                User_Role_Set("GSU Staff");
            } else if (_.isEqual(User.Access, Pattern_Administrator)) {
                User_Role_Set("Administrator");
            } else {
                User_Role_Set("Custom");
            }
        } else if (Origin === "List") {
            if (User.isSystemAdmin) {
                return "System Administrator";
            }
            if (_.isEqual(User.Access, Pattern_Teacher)) {
                return "Teacher";
            } else if (_.isEqual(User.Access, Pattern_Guard)) {
                return "Guard";
            } else if (_.isEqual(User.Access, Pattern_Staff)) {
                return "OSA Staff";
            } else if (_.isEqual(User.Access, Pattern_Staff_GSU)) {
                return "GSU Staff";
            } else if (_.isEqual(User.Access, Pattern_Administrator)) {
                return "Administrator";
            } else {
                return "Custom";
            }
        }

    }

    const User_Status_Get = (Data, Type) => {
        if (Type === "Approval") {
            if (Data.Approval.State === "Pending") {
                return "Pending approval";
            } else if (Data.Approval.State === "Rejected") {
                return "Rejected";
            } else if (Data.Approval.State === "Deactivated") {
                return "Deactivated";
            } else if (Data.Approval.State === "Approved") {
                return User_Role_Get(Data, "List");
            }
        } else if (Type === "Approval_Raw" || !Type) {
            return Data.Approval.State;
        }
    }

    const User_Change_Password = async () => {
        const { Response, Data } = await Confirmer_Confirm('Window_User_Edit');
        if (Response === "Confirmed") {
            const Payload = {
                Password_Old: Data.Old,
                Password_New: Data.New
            }
            try {
                const Result = await Accounts_Update_Password(Payload);
                const { Response, Data } = await Confirmer_Confirm('Window_User_Logout');
                if (Response === "Confirmed") {
                    Logout();
                }
            } catch (Error) {
                if (Error.response && Error.response.status === 400) {
                    console.error("Incorrect password.");
                    const { Response, Data } = await Confirmer_Confirm('Window_User_IncorrectPassword');
                    if (Response === "Confirmed") {
                        User_Change_Password();
                    }
                } else {
                    console.error(Error);
                }
            }

        }
    }

    const User_Reset_Password = async (Email) => {
        try {
            const Result = await Accounts_ResetPassword({ Email });
            if (Result.data.State === "Success") {
                const { Response, Data } = await Confirmer_Confirm("Window_ResetPassword_EmailSent");
                if (Response === "Confirmed") {
                    Navigate("/");
                }
                
            }
            return Result.data;
        } catch (Error) {
            console.error(Error);
        }
    }

    const User_Reset_Password_Final = async (Token, Password) => {
        try {
            const Payload = {
                Token: Token,
                NewPassword: Password
            }
            const Result = await Accounts_ResetPassword_Final(Payload)
                .then((res) => {
                    // console.log(res.data);
                    return res.data;
                    return "SUCCESS";
                })
                .catch((err) => {
                    // console.log(err.response?.data?.code);
                    let Error = err.response?.data?.code;
                    // console.log(err.response?.data);
                    return err.response?.data;
                    switch (Error) {
                        case "MISSINGFIELDS":
                            return "Missing";
                            break;
                        case "SUCCESS":
                            return "Missing";
                            break;
                        case "INVALIDTOKEN":
                            return "Token_Invalid";
                            break;
                        case "UNVERIFIEDTOKEN":
                            return "Token_Unverified";
                            break;
                        case "EXPIRED":
                            return "Token_Expired";
                            break;
                        case "ERROR":
                            return "Error";
                            break;
                    }
                });
            return Result;
        } catch (Error) {
            console.error(Error);
        }
    }

    const User_Reset_Password_Verify = async (Token) => {
        try {
            const res = await Accounts_ResetPassword_Verify({ Token });
            return "SUCCESS";
        } catch (err) {
            return err.response?.data?.code || "ERROR";
        }
    }

    const Account_Select = async (ID) => {
        try {
            Accounts_ChangeInProgress_Set(true);
            Accounts_Mode_Set("View");
            const Data = await Account_Fetch_ByID(ID);
            Accounts_Selected_Set(Data);
            Accounts_ChangeInProgress_Set(false);
        } catch (Error) {
            Accounts_Mode_Set(null);
            Accounts_ChangeInProgress_Set(false);
        }
    }

    return (
        <Context_Accounts.Provider value={{
            Accounts_List,
            Accounts_List_Set,
            Accounts_isLoading,
            Accounts_isLoading_Set,
            Accounts_Error,
            Accounts_Error_Set,
            Accounts_Selected,
            Accounts_Selected_Set,
            Accounts_ChangeInProgress,
            Accounts_ChangeInProgress_Set,
            Account_Fetch_ByID,
            Account_Fetch_ByID_FromState,
            Account_Fetch_ByID_Basic,
            Accounts_Fetch_ByID_Many_Basic,
            Account_Update,
            Accounts_Refresh,
            Account_Select,
            Accounts_List_Approved,
            Accounts_List_Pending,
            Accounts_List_Deactivated,
            Accounts_List_Rejected,
            Accounts_Mode,
            Accounts_Mode_Set,
            User_Role_Get,
            User,
            User_Permission,
            User_Role,
            User_Change_Password,
            User_Reset_Password,
            User_Reset_Password_Final,
            User_Reset_Password_Verify,
            Pattern_Administrator,
            Pattern_Staff,
            Pattern_Staff_GSU,
            Pattern_Teacher,
            Pattern_Guard,
            Pattern_Empty,
            Account_Approve,
            Account_Reject,
            Account_Reinstate,
            Account_Deactivate,
            Account_Reactivate,
            User_Status_Get,
            Accounts_Selector_List,
            Accounts_Selector_List_Set
        }}>
            {children}
        </Context_Accounts.Provider>
    )
}

export function useAccounts() {
    return useContext(Context_Accounts);
}